/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { XpMultiplier } from './XpMultiplier';
import {
    XpMultiplierFromJSON,
    XpMultiplierFromJSONTyped,
    XpMultiplierToJSON,
    XpMultiplierToJSONTyped,
} from './XpMultiplier';
import type { CheatFlagHistoryEntry } from './CheatFlagHistoryEntry';
import {
    CheatFlagHistoryEntryFromJSON,
    CheatFlagHistoryEntryFromJSONTyped,
    CheatFlagHistoryEntryToJSON,
    CheatFlagHistoryEntryToJSONTyped,
} from './CheatFlagHistoryEntry';
import type { DiscordInfo } from './DiscordInfo';
import {
    DiscordInfoFromJSON,
    DiscordInfoFromJSONTyped,
    DiscordInfoToJSON,
    DiscordInfoToJSONTyped,
} from './DiscordInfo';
import type { GamerTag } from './GamerTag';
import {
    GamerTagFromJSON,
    GamerTagFromJSONTyped,
    GamerTagToJSON,
    GamerTagToJSONTyped,
} from './GamerTag';
import type { CookieConsent } from './CookieConsent';
import {
    CookieConsentFromJSON,
    CookieConsentFromJSONTyped,
    CookieConsentToJSON,
    CookieConsentToJSONTyped,
} from './CookieConsent';
import type { DateOfBirthHistoryEntry } from './DateOfBirthHistoryEntry';
import {
    DateOfBirthHistoryEntryFromJSON,
    DateOfBirthHistoryEntryFromJSONTyped,
    DateOfBirthHistoryEntryToJSON,
    DateOfBirthHistoryEntryToJSONTyped,
} from './DateOfBirthHistoryEntry';
import type { AddressBook } from './AddressBook';
import {
    AddressBookFromJSON,
    AddressBookFromJSONTyped,
    AddressBookToJSON,
    AddressBookToJSONTyped,
} from './AddressBook';
import type { UserOrigin } from './UserOrigin';
import {
    UserOriginFromJSON,
    UserOriginFromJSONTyped,
    UserOriginToJSON,
    UserOriginToJSONTyped,
} from './UserOrigin';
import type { SubscriptionTierStatus } from './SubscriptionTierStatus';
import {
    SubscriptionTierStatusFromJSON,
    SubscriptionTierStatusFromJSONTyped,
    SubscriptionTierStatusToJSON,
    SubscriptionTierStatusToJSONTyped,
} from './SubscriptionTierStatus';
import type { AccountStatusHistoryEntry } from './AccountStatusHistoryEntry';
import {
    AccountStatusHistoryEntryFromJSON,
    AccountStatusHistoryEntryFromJSONTyped,
    AccountStatusHistoryEntryToJSON,
    AccountStatusHistoryEntryToJSONTyped,
} from './AccountStatusHistoryEntry';
import type { Asset } from './Asset';
import {
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    AssetToJSONTyped,
} from './Asset';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

import { type GodAdmin, GodAdminFromJSONTyped, GodAdminToJSON, GodAdminToJSONTyped } from './GodAdmin';
import { type MerchantUser, MerchantUserFromJSONTyped, MerchantUserToJSON, MerchantUserToJSONTyped } from './MerchantUser';
import { type Partner, PartnerFromJSONTyped, PartnerToJSON, PartnerToJSONTyped } from './Partner';
import { type StandardAdmin, StandardAdminFromJSONTyped, StandardAdminToJSON, StandardAdminToJSONTyped } from './StandardAdmin';
import { type StandardUser, StandardUserFromJSONTyped, StandardUserToJSON, StandardUserToJSONTyped } from './StandardUser';
import { type SupportAgent, SupportAgentFromJSONTyped, SupportAgentToJSON, SupportAgentToJSONTyped } from './SupportAgent';
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    updatedAt: number;
    /**
     * 
     * @type {UserType}
     * @memberof User
     */
    type: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    disabled: boolean;
    /**
     * Unix ms timestamp until which clip rename is barred. Server-internal — do not surface in user-facing UI.
     * @type {number}
     * @memberof User
     */
    clipRenameSuspendedUntil?: number;
    /**
     * Server-internal rolling-window strike count for clip-rename moderation. Not for client display.
     * @type {number}
     * @memberof User
     */
    clipRenameStrikeCount?: number;
    /**
     * Server-internal start timestamp of the active strike window (paired with clipRenameStrikeCount).
     * @type {number}
     * @memberof User
     */
    clipRenameStrikeWindowStart?: number;
    /**
     * Per-account toggle for clip recording. When false, clipTriggerEvaluator early-returns before claiming cooldown/budget. Defaults to true.
     * @type {boolean}
     * @memberof User
     */
    clipsRecordingEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    skipped?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    notificationMenuOrderStatus?: boolean;
    /**
     * Master marketing switch. False silences all marketing on every channel.
     * @type {boolean}
     * @memberof User
     */
    notificationMarketing?: boolean;
    /**
     * Narrows notificationMarketing to the email channel. Absent means no preference expressed, which is permitted — it is not the same as an explicit true.
     * @type {boolean}
     * @memberof User
     */
    notificationMarketingEmail?: boolean;
    /**
     * Narrows notificationMarketing to Discord DMs. Absent means no preference expressed.
     * @type {boolean}
     * @memberof User
     */
    notificationMarketingDiscord?: boolean;
    /**
     * Narrows notificationMarketing to in-app toast and in-game overlay together.
     * @type {boolean}
     * @memberof User
     */
    notificationMarketingInApp?: boolean;
    /**
     * Admin portal Quick List — routes this admin pinned, in their order. Capped at 10. Empty for non-admin users.
     * @type {Array<string>}
     * @memberof User
     */
    adminPinnedRoutes?: Array<string>;
    /**
     * Email deliverability status from SendGrid
     * @type {string}
     * @memberof User
     */
    emailStatus?: UserEmailStatusEnum;
    /**
     * Admin-controlled flag to permanently exclude user from marketing emails
     * @type {boolean}
     * @memberof User
     */
    marketingBlacklist?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof User
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ordersEmail?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof User
     */
    ordersPhoneNumber?: PhoneNumber;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ordersFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ordersLastName?: string;
    /**
     * See moment.tz.names()
     * @type {string}
     * @memberof User
     */
    timeZone?: string;
    /**
     * 
     * @type {Array<AddressBook>}
     * @memberof User
     */
    addresses?: Array<AddressBook>;
    /**
     * 
     * @type {Array<string>}
     * @memberof User
     */
    favorites?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    lastSpin?: number;
    /**
     * url to load the gravatar associated with the user's email
     * @type {string}
     * @memberof User
     */
    gravatar?: string;
    /**
     * ID of the user's default payment method, if present
     * @type {string}
     * @memberof User
     */
    defaultPaymentMethodId?: string;
    /**
     * 
     * @type {Asset}
     * @memberof User
     */
    profilePicture?: Asset;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    level?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    experiencePoints?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    community?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    leftCommunityAt?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    joinedCommunityAt?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    previousCommunity?: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    pointsEarnedForCommunity?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    monthlyPointsEarnedForCommunity?: number;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    rankWithinCommunity?: number;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isEjectedFromCommunity?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    nftProfilePicture?: string;
    /**
     * 
     * @type {DiscordInfo}
     * @memberof User
     */
    discord?: DiscordInfo;
    /**
     * Platform feature/access entitlements granted to this user (hub access, exclusive quests, badges)
     * @type {Array<string>}
     * @memberof User
     */
    platformEntitlements?: Array<string>;
    /**
     * 
     * @type {Array<XpMultiplier>}
     * @memberof User
     */
    xpMultipliers?: Array<XpMultiplier>;
    /**
     * 
     * @type {{ [key: string]: GamerTag; }}
     * @memberof User
     */
    gamerTags?: { [key: string]: GamerTag; };
    /**
     * 
     * @type {string}
     * @memberof User
     */
    stripeSubscriptionScheduleId?: string;
    /**
     * Persisted DevourPlay Access tier id (source of truth; written by Stripe/ownership webhooks, not resolved on read)
     * @type {string}
     * @memberof User
     */
    subscriptionTier?: string;
    /**
     * 
     * @type {SubscriptionTierStatus}
     * @memberof User
     */
    subscriptionTierStatus?: SubscriptionTierStatus;
    /**
     * 
     * @type {UserOrigin}
     * @memberof User
     */
    origin?: UserOrigin;
    /**
     * Unix timestamp (ms) when user was last seen online
     * @type {number}
     * @memberof User
     */
    lastSeen?: number;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isEmailLocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    isBlitzConnected?: boolean;
    /**
     * Minelab Realm user_id this DevourPlay account is linked to. Set during RTTR registration handoff (POST /challenges/:slug/register) and cleared by the admin RTTR test-reset endpoint. Used client-side as the identity-handoff gate: webframe loads with `?realm_uuid=X` compare against this; mismatch forces a logout. Identifier is not secret (a numeric Realm user id) — fine to expose on owner-self responses.
     * @type {string}
     * @memberof User
     */
    realmUuid?: string;
    /**
     * True when this account has ever run the DevourPlay desktop (Electron) app — derived from lastElectronVersionAt, which the backend stamps from the `devourplay-electron/<version>` User-Agent on authed calls. Owner-self only (projected in GET /users/profile, omitted from prepareForResponse) so web surfaces like game-page Recent Clips can tell a returning app-user (show 'no clips yet') from a browser-only visitor (show the app download CTA).
     * @type {boolean}
     * @memberof User
     */
    hasDesktopApp?: boolean;
    /**
     * True when this account has a date of birth on file. Owner-self only (projected in GET /users/profile, omitted from prepareForResponse). A boolean rather than the date itself because the only client question is whether to ask for one: entering a competition that costs money requires an age of at least 18, and an account with no date on file is refused until it supplies one. The date itself is never needed client-side, so it is not sent.
     * @type {boolean}
     * @memberof User
     */
    hasDateOfBirth?: boolean;
    /**
     * Composite identity-trust score (0-100). Persisted; recomputed by TrustScoreService on signal-change events. Admin-only — projected explicitly by admin endpoints, omitted from prepareForResponse on player-facing routes.
     * @type {number}
     * @memberof User
     */
    trustScore?: number;
    /**
     * Unix ms timestamp of last trust-score compute. Stale values are still returned; admin UI can flag freshness.
     * @type {number}
     * @memberof User
     */
    trustComputedAt?: number;
    /**
     * True when the score was computed without enough signal evidence to be reliable (new account, no linked platforms, no payment history).
     * @type {boolean}
     * @memberof User
     */
    trustColdStart?: boolean;
    /**
     * Sprint 4 WU S4.4.1 — Matchmaking pool slot. Computed nightly from trustScore. LOW only matches LOW; HIGH never matches LOW; RESTRICTED blocks paid matching entirely. Admin-only — projected explicitly by admin endpoints.
     * @type {string}
     * @memberof User
     */
    poolAssignment?: UserPoolAssignmentEnum;
    /**
     * Unix ms timestamp of last pool-assignment compute.
     * @type {number}
     * @memberof User
     */
    poolComputedAt?: number;
    /**
     * Unix ms timestamp of the most recent UP-tier transition. Drives graduation anti-thrash gate.
     * @type {number}
     * @memberof User
     */
    poolLastPromotedAt?: number;
    /**
     * Cached cohort membership. True when user has any evidence of gameplay engagement; gamer-only signals only contribute to the score when this is true. Admin-only — projected explicitly by admin endpoints.
     * @type {boolean}
     * @memberof User
     */
    isDevourPlayUser?: boolean;
    /**
     * Unix ms timestamp when an admin flagged this user as a confirmed cheat. Null/absent when not flagged. Drives a -10 trust-score deduction. Independent of User.disabled. Admin-only field.
     * @type {number}
     * @memberof User
     */
    cheatFlaggedAt?: number;
    /**
     * Free-text rationale recorded when the flag was set. Surfaces in the modal tooltip + audit log. Admin-only field.
     * @type {string}
     * @memberof User
     */
    cheatFlaggedReason?: string;
    /**
     * ObjectId of the admin who set the current flag. Set together with cheatFlaggedAt; cleared when flag is cleared. Admin-only field.
     * @type {string}
     * @memberof User
     */
    cheatFlaggedBy?: string;
    /**
     * Append-only audit trail of flag set/clear transitions. Each entry records action, admin, timestamp, and reason. Capped at 500 most recent entries. Admin-only field.
     * @type {Array<CheatFlagHistoryEntry>}
     * @memberof User
     */
    cheatFlagHistory?: Array<CheatFlagHistoryEntry>;
    /**
     * Why the account is currently disabled. Absent when enabled. Admin-only field.
     * @type {string}
     * @memberof User
     */
    disabledReason?: string;
    /**
     * Unix ms when the account was last disabled. Admin-only field.
     * @type {number}
     * @memberof User
     */
    disabledAt?: number;
    /**
     * ObjectId of the admin who disabled the account; absent when the player did it themselves (under-18 self-report). Admin-only field.
     * @type {string}
     * @memberof User
     */
    disabledBy?: string;
    /**
     * Append-only disable / enable transitions with reason. Admin-only field.
     * @type {Array<AccountStatusHistoryEntry>}
     * @memberof User
     */
    disableHistory?: Array<AccountStatusHistoryEntry>;
    /**
     * Append-only admin changes to the date of birth, with reason. Admin-only field.
     * @type {Array<DateOfBirthHistoryEntry>}
     * @memberof User
     */
    dateOfBirthHistory?: Array<DateOfBirthHistoryEntry>;
    /**
     * True when this account has a non-empty username (stored as nickname). Owner-self only, projected in GET /users/profile; the root identity modal reads it.
     * @type {boolean}
     * @memberof User
     */
    hasUsername?: boolean;
    /**
     * 
     * @type {CookieConsent}
     * @memberof User
     */
    cookieConsent?: CookieConsent;
}


/**
 * @export
 */
export const UserEmailStatusEnum = {
    valid: 'valid',
    bounced: 'bounced',
    complained: 'complained',
    invalid: 'invalid'
} as const;
export type UserEmailStatusEnum = typeof UserEmailStatusEnum[keyof typeof UserEmailStatusEnum];

/**
 * @export
 */
export const UserPoolAssignmentEnum = {
    LOW_TRUST_POOL: 'LOW_TRUST_POOL',
    STANDARD_POOL: 'STANDARD_POOL',
    HIGH_TRUST_POOL: 'HIGH_TRUST_POOL',
    RESTRICTED: 'RESTRICTED'
} as const;
export type UserPoolAssignmentEnum = typeof UserPoolAssignmentEnum[keyof typeof UserPoolAssignmentEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('disabled' in value) || value['disabled'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'GOD_ADMIN') {
            return GodAdminFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'MERCHANT') {
            return MerchantUserFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'PARTNER') {
            return PartnerFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'STANDARD_ADMIN') {
            return StandardAdminFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'STANDARD_USER') {
            return StandardUserFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'SUPPORT_AGENT') {
            return SupportAgentFromJSONTyped(json, ignoreDiscriminator);
        }
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'type': UserTypeFromJSON(json['type']),
        'disabled': json['disabled'],
        'clipRenameSuspendedUntil': json['clipRenameSuspendedUntil'] == null ? undefined : json['clipRenameSuspendedUntil'],
        'clipRenameStrikeCount': json['clipRenameStrikeCount'] == null ? undefined : json['clipRenameStrikeCount'],
        'clipRenameStrikeWindowStart': json['clipRenameStrikeWindowStart'] == null ? undefined : json['clipRenameStrikeWindowStart'],
        'clipsRecordingEnabled': json['clipsRecordingEnabled'] == null ? undefined : json['clipsRecordingEnabled'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'skipped': json['skipped'] == null ? undefined : json['skipped'],
        'notificationMenuOrderStatus': json['notificationMenuOrderStatus'] == null ? undefined : json['notificationMenuOrderStatus'],
        'notificationMarketing': json['notificationMarketing'] == null ? undefined : json['notificationMarketing'],
        'notificationMarketingEmail': json['notificationMarketingEmail'] == null ? undefined : json['notificationMarketingEmail'],
        'notificationMarketingDiscord': json['notificationMarketingDiscord'] == null ? undefined : json['notificationMarketingDiscord'],
        'notificationMarketingInApp': json['notificationMarketingInApp'] == null ? undefined : json['notificationMarketingInApp'],
        'adminPinnedRoutes': json['adminPinnedRoutes'] == null ? undefined : json['adminPinnedRoutes'],
        'emailStatus': json['emailStatus'] == null ? undefined : json['emailStatus'],
        'marketingBlacklist': json['marketingBlacklist'] == null ? undefined : json['marketingBlacklist'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'ordersEmail': json['ordersEmail'] == null ? undefined : json['ordersEmail'],
        'ordersPhoneNumber': json['ordersPhoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['ordersPhoneNumber']),
        'ordersFirstName': json['ordersFirstName'] == null ? undefined : json['ordersFirstName'],
        'ordersLastName': json['ordersLastName'] == null ? undefined : json['ordersLastName'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(AddressBookFromJSON)),
        'favorites': json['favorites'] == null ? undefined : json['favorites'],
        'lastSpin': json['lastSpin'] == null ? undefined : json['lastSpin'],
        'gravatar': json['gravatar'] == null ? undefined : json['gravatar'],
        'defaultPaymentMethodId': json['defaultPaymentMethodId'] == null ? undefined : json['defaultPaymentMethodId'],
        'profilePicture': json['profilePicture'] == null ? undefined : AssetFromJSON(json['profilePicture']),
        'level': json['level'] == null ? undefined : json['level'],
        'experiencePoints': json['experiencePoints'] == null ? undefined : json['experiencePoints'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'community': json['community'] == null ? undefined : json['community'],
        'leftCommunityAt': json['leftCommunityAt'] == null ? undefined : json['leftCommunityAt'],
        'joinedCommunityAt': json['joinedCommunityAt'] == null ? undefined : json['joinedCommunityAt'],
        'previousCommunity': json['previousCommunity'] == null ? undefined : json['previousCommunity'],
        'pointsEarnedForCommunity': json['pointsEarnedForCommunity'] == null ? undefined : json['pointsEarnedForCommunity'],
        'monthlyPointsEarnedForCommunity': json['monthlyPointsEarnedForCommunity'] == null ? undefined : json['monthlyPointsEarnedForCommunity'],
        'rankWithinCommunity': json['rankWithinCommunity'] == null ? undefined : json['rankWithinCommunity'],
        'isEjectedFromCommunity': json['isEjectedFromCommunity'] == null ? undefined : json['isEjectedFromCommunity'],
        'nftProfilePicture': json['nftProfilePicture'] == null ? undefined : json['nftProfilePicture'],
        'discord': json['discord'] == null ? undefined : DiscordInfoFromJSON(json['discord']),
        'platformEntitlements': json['platformEntitlements'] == null ? undefined : json['platformEntitlements'],
        'xpMultipliers': json['xpMultipliers'] == null ? undefined : ((json['xpMultipliers'] as Array<any>).map(XpMultiplierFromJSON)),
        'gamerTags': json['gamerTags'] == null ? undefined : (mapValues(json['gamerTags'], GamerTagFromJSON)),
        'stripeSubscriptionScheduleId': json['stripeSubscriptionScheduleId'] == null ? undefined : json['stripeSubscriptionScheduleId'],
        'subscriptionTier': json['subscriptionTier'] == null ? undefined : json['subscriptionTier'],
        'subscriptionTierStatus': json['subscriptionTierStatus'] == null ? undefined : SubscriptionTierStatusFromJSON(json['subscriptionTierStatus']),
        'origin': json['origin'] == null ? undefined : UserOriginFromJSON(json['origin']),
        'lastSeen': json['lastSeen'] == null ? undefined : json['lastSeen'],
        'isEmailLocked': json['isEmailLocked'] == null ? undefined : json['isEmailLocked'],
        'isBlitzConnected': json['isBlitzConnected'] == null ? undefined : json['isBlitzConnected'],
        'realmUuid': json['realmUuid'] == null ? undefined : json['realmUuid'],
        'hasDesktopApp': json['hasDesktopApp'] == null ? undefined : json['hasDesktopApp'],
        'hasDateOfBirth': json['hasDateOfBirth'] == null ? undefined : json['hasDateOfBirth'],
        'trustScore': json['trustScore'] == null ? undefined : json['trustScore'],
        'trustComputedAt': json['trustComputedAt'] == null ? undefined : json['trustComputedAt'],
        'trustColdStart': json['trustColdStart'] == null ? undefined : json['trustColdStart'],
        'poolAssignment': json['poolAssignment'] == null ? undefined : json['poolAssignment'],
        'poolComputedAt': json['poolComputedAt'] == null ? undefined : json['poolComputedAt'],
        'poolLastPromotedAt': json['poolLastPromotedAt'] == null ? undefined : json['poolLastPromotedAt'],
        'isDevourPlayUser': json['isDevourPlayUser'] == null ? undefined : json['isDevourPlayUser'],
        'cheatFlaggedAt': json['cheatFlaggedAt'] == null ? undefined : json['cheatFlaggedAt'],
        'cheatFlaggedReason': json['cheatFlaggedReason'] == null ? undefined : json['cheatFlaggedReason'],
        'cheatFlaggedBy': json['cheatFlaggedBy'] == null ? undefined : json['cheatFlaggedBy'],
        'cheatFlagHistory': json['cheatFlagHistory'] == null ? undefined : ((json['cheatFlagHistory'] as Array<any>).map(CheatFlagHistoryEntryFromJSON)),
        'disabledReason': json['disabledReason'] == null ? undefined : json['disabledReason'],
        'disabledAt': json['disabledAt'] == null ? undefined : json['disabledAt'],
        'disabledBy': json['disabledBy'] == null ? undefined : json['disabledBy'],
        'disableHistory': json['disableHistory'] == null ? undefined : ((json['disableHistory'] as Array<any>).map(AccountStatusHistoryEntryFromJSON)),
        'dateOfBirthHistory': json['dateOfBirthHistory'] == null ? undefined : ((json['dateOfBirthHistory'] as Array<any>).map(DateOfBirthHistoryEntryFromJSON)),
        'hasUsername': json['hasUsername'] == null ? undefined : json['hasUsername'],
        'cookieConsent': json['cookieConsent'] == null ? undefined : CookieConsentFromJSON(json['cookieConsent']),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'GOD_ADMIN':
                return GodAdminToJSONTyped(value as GodAdmin, ignoreDiscriminator);
            case 'MERCHANT':
                return MerchantUserToJSONTyped(value as MerchantUser, ignoreDiscriminator);
            case 'PARTNER':
                return PartnerToJSONTyped(value as Partner, ignoreDiscriminator);
            case 'STANDARD_ADMIN':
                return StandardAdminToJSONTyped(value as StandardAdmin, ignoreDiscriminator);
            case 'STANDARD_USER':
                return StandardUserToJSONTyped(value as StandardUser, ignoreDiscriminator);
            case 'SUPPORT_AGENT':
                return SupportAgentToJSONTyped(value as SupportAgent, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'type': UserTypeToJSON(value['type']),
        'disabled': value['disabled'],
        'clipRenameSuspendedUntil': value['clipRenameSuspendedUntil'],
        'clipRenameStrikeCount': value['clipRenameStrikeCount'],
        'clipRenameStrikeWindowStart': value['clipRenameStrikeWindowStart'],
        'clipsRecordingEnabled': value['clipsRecordingEnabled'],
        'deleted': value['deleted'],
        'skipped': value['skipped'],
        'notificationMenuOrderStatus': value['notificationMenuOrderStatus'],
        'notificationMarketing': value['notificationMarketing'],
        'notificationMarketingEmail': value['notificationMarketingEmail'],
        'notificationMarketingDiscord': value['notificationMarketingDiscord'],
        'notificationMarketingInApp': value['notificationMarketingInApp'],
        'adminPinnedRoutes': value['adminPinnedRoutes'],
        'emailStatus': value['emailStatus'],
        'marketingBlacklist': value['marketingBlacklist'],
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'ordersEmail': value['ordersEmail'],
        'ordersPhoneNumber': PhoneNumberToJSON(value['ordersPhoneNumber']),
        'ordersFirstName': value['ordersFirstName'],
        'ordersLastName': value['ordersLastName'],
        'timeZone': value['timeZone'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(AddressBookToJSON)),
        'favorites': value['favorites'],
        'lastSpin': value['lastSpin'],
        'gravatar': value['gravatar'],
        'defaultPaymentMethodId': value['defaultPaymentMethodId'],
        'profilePicture': AssetToJSON(value['profilePicture']),
        'level': value['level'],
        'experiencePoints': value['experiencePoints'],
        'nickname': value['nickname'],
        'community': value['community'],
        'leftCommunityAt': value['leftCommunityAt'],
        'joinedCommunityAt': value['joinedCommunityAt'],
        'previousCommunity': value['previousCommunity'],
        'pointsEarnedForCommunity': value['pointsEarnedForCommunity'],
        'monthlyPointsEarnedForCommunity': value['monthlyPointsEarnedForCommunity'],
        'rankWithinCommunity': value['rankWithinCommunity'],
        'isEjectedFromCommunity': value['isEjectedFromCommunity'],
        'nftProfilePicture': value['nftProfilePicture'],
        'discord': DiscordInfoToJSON(value['discord']),
        'platformEntitlements': value['platformEntitlements'],
        'xpMultipliers': value['xpMultipliers'] == null ? undefined : ((value['xpMultipliers'] as Array<any>).map(XpMultiplierToJSON)),
        'gamerTags': value['gamerTags'] == null ? undefined : (mapValues(value['gamerTags'], GamerTagToJSON)),
        'stripeSubscriptionScheduleId': value['stripeSubscriptionScheduleId'],
        'subscriptionTier': value['subscriptionTier'],
        'subscriptionTierStatus': SubscriptionTierStatusToJSON(value['subscriptionTierStatus']),
        'origin': UserOriginToJSON(value['origin']),
        'lastSeen': value['lastSeen'],
        'isEmailLocked': value['isEmailLocked'],
        'isBlitzConnected': value['isBlitzConnected'],
        'realmUuid': value['realmUuid'],
        'hasDesktopApp': value['hasDesktopApp'],
        'hasDateOfBirth': value['hasDateOfBirth'],
        'trustScore': value['trustScore'],
        'trustComputedAt': value['trustComputedAt'],
        'trustColdStart': value['trustColdStart'],
        'poolAssignment': value['poolAssignment'],
        'poolComputedAt': value['poolComputedAt'],
        'poolLastPromotedAt': value['poolLastPromotedAt'],
        'isDevourPlayUser': value['isDevourPlayUser'],
        'cheatFlaggedAt': value['cheatFlaggedAt'],
        'cheatFlaggedReason': value['cheatFlaggedReason'],
        'cheatFlaggedBy': value['cheatFlaggedBy'],
        'cheatFlagHistory': value['cheatFlagHistory'] == null ? undefined : ((value['cheatFlagHistory'] as Array<any>).map(CheatFlagHistoryEntryToJSON)),
        'disabledReason': value['disabledReason'],
        'disabledAt': value['disabledAt'],
        'disabledBy': value['disabledBy'],
        'disableHistory': value['disableHistory'] == null ? undefined : ((value['disableHistory'] as Array<any>).map(AccountStatusHistoryEntryToJSON)),
        'dateOfBirthHistory': value['dateOfBirthHistory'] == null ? undefined : ((value['dateOfBirthHistory'] as Array<any>).map(DateOfBirthHistoryEntryToJSON)),
        'hasUsername': value['hasUsername'],
        'cookieConsent': CookieConsentToJSON(value['cookieConsent']),
    };
}

